// 组合购买模块 JavaScript
class BundlePurchaseComponent extends HTMLElement {
    constructor() {
        super();
        this.currentSlide = 0;
        this.slides = [];
        this.productCache = {};
        this.bundleData = [];
    }

    connectedCallback() {
        this.init();
    }

    async init() {
        try {
            // 获取数据
            const wrapper = this.closest('.bundle-purchase__wrapper');
            const sectionId = wrapper ? wrapper.dataset.sectionId : '';

            const dataScript = document.getElementById(`bundle-purchase-data-${sectionId}`);
            const productDataScript = document.getElementById(`bundle-product-data-${sectionId}`);

            if (!dataScript) {
                console.error('Bundle purchase data not found');
                this.innerHTML = '<p style="text-align:center;padding:20px;">No bundle data available</p>';
                return;
            }

            this.bundleData = JSON.parse(dataScript.textContent);

            // 加载预处理的产品数据
            if (productDataScript) {
                this.productCache = JSON.parse(productDataScript.textContent);
            }

            if (!Array.isArray(this.bundleData) || this.bundleData.length === 0) {
                console.warn('Bundle data is empty or invalid');
                this.innerHTML = '';
                return;
            }

            // 获取标题
            this.title = this.dataset.title || 'Match & Save';

            // 生成 HTML
            await this.render();

            // 初始化交互
            this.initInteractions();

        } catch (error) {
            console.error('Error initializing bundle purchase:', error);
            this.innerHTML = '<p style="text-align:center;padding:20px;color:red;">Error loading bundle data</p>';
        }
    }

    async render() {
        // 使用 Swiper 结构
        const html = `
                <div class="bundle-purchase__header">
                    <div class="bundle-purchase__title">${this.title}</div>
                </div>
            <div class="swiper bundle-purchase__swiper">
                <div class="swiper-wrapper">
                ${this.bundleData.map((bundle, index) => this.renderSlide(bundle, index)).join('')}
                </div>
                ${this.bundleData.length > 1 ? `
                <div class="swiper-button-prev bundle-purchase__swiper-button-prev"></div>
                <div class="swiper-button-next bundle-purchase__swiper-button-next"></div>
                ` : ''}
            </div>
            `;

        this.innerHTML = html;

        // 如果没有预加载的产品数据，尝试异步加载
        if (Object.keys(this.productCache).length === 0) {
            await this.loadAllProducts();
        } else {
            // 直接渲染预加载的产品
            this.renderAllProducts();

            // 初始化价格
            this.slides = Array.from(this.querySelectorAll('.bundle-purchase__slide'));
            if (this.slides.length > 0) {
                this.updatePricing(this.slides[0]);
            }
        }
    }

    renderSlide(bundle, index) {
        const products = bundle.discount_products || [];

        return `
      <div class="swiper-slide bundle-purchase__slide" 
           data-slide-index="${index}">
      

        <div class="bundle-purchase__content">
          <!-- 左侧产品区 -->
          <div class="bundle-purchase__products">
            <div class="bundle-purchase__products-container">
              <div class="bundle-purchase__products-track">
                ${products.map((gid, idx) => this.renderProductItem(gid, index, idx, products.length)).join('')}
              </div>
            </div>
          </div>

          <!-- 右侧购买信息区 -->
          <div class="bundle-purchase__summary">
            <div class="bundle-purchase__summary-content">
              <p class="bundle-purchase__selected-count">
                Selected <span data-selected-count>${products.length}</span> Items
              </p>

              <div class="bundle-purchase__pricing">
                <div class="bundle-purchase__pricing-row" style="color: #7F4530;font-family: var(--font-semibold-family);">
                  <span>Buy Together Save:</span>
                  <span class="bundle-purchase__discount" data-discount-amount>
                    ${this.formatDiscount(bundle)}
                  </span>
                </div>
                <div class="bundle-purchase__pricing-row">
                  <span>Subtotal:<span class="bundle-purchase__total" data-total>$0.00</span></span>
                  <span class="bundle-purchase__subtotal" data-subtotal>$0.00</span>
                </div>
              </div>

              <button class="bundle-purchase__add-to-cart button button--full-width button--primary" data-add-to-cart>
                <span>Add to cart</span>
                <div class="loading__spinner hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                </div>
            </button>
            </div>

            <!-- 隐藏的数据属性 -->
            <div class="bundle-purchase__data" style="display: none;">
              <span data-bundle-name>${bundle.buy_together_name || ''}</span>
              <span data-discount-type>${bundle.discount_type || 'percentage'}</span>
              <span data-discount-value2>${bundle.disount_value || 0}</span>
              <span data-discount-value3>${bundle.discount_value2 || 0}</span>
              <span data-two-code>${bundle.two_item_combo_discount_code || ''}</span>
              <span data-three-code>${bundle.three_item_combo_discount_code || ''}</span>
            </div>
          </div>
        </div>
      </div>
    `;
    }

    renderProductItem(gid, bundleIndex, productIndex, totalProducts) {
        const plusIcon = productIndex < totalProducts - 1 ?
            '<svg class="icon-plus bundle-purchase__plus-icon"><use href="#icon-plus"></use></svg>'
            : '';

        return `
      <div class="bundle-purchase__product-item" 
           data-product-gid="${gid}"
           data-product-index="${productIndex}">
        <div class="bundle-purchase__product-checkbox">
          <input type="checkbox" 
                 id="bundle-${bundleIndex}-${productIndex}"
                 data-product-gid="${gid}"
                 checked>
          <label for="bundle-${bundleIndex}-${productIndex}">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M15 5L7 13L3 9" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </label>
        </div>

        <div class="bundle-purchase__product-image">
          <div class="bundle-purchase__product-placeholder"></div>
        </div>

        <h3 class="bundle-purchase__product-title">Loading...</h3>
      </div>
      ${plusIcon}
    `;
    }


    formatDiscount(bundle) {
        const discountType = bundle.discount_type || 'percentage';
        const value = bundle.disount_value || 0;

        if (discountType === 'percentage') {
            return `${value}%`;
        } else {
            return `$${value.toFixed(2)}`;
        }
    }

    // 加载所有产品数据
    async loadAllProducts() {
        const allGids = new Set();

        // 收集所有产品 GID
        this.bundleData.forEach(bundle => {
            if (bundle.discount_products) {
                bundle.discount_products.forEach(gid => allGids.add(gid));
            }
        });


        // 批量加载
        const promises = Array.from(allGids).map(gid => this.loadProduct(gid));
        await Promise.all(promises);

        // 渲染产品信息
        this.renderAllProducts();

        // 初始化价格
        this.slides = Array.from(this.querySelectorAll('.bundle-purchase__slide'));
        if (this.slides.length > 0) {
            this.updatePricing(this.slides[0]);
        }
    }

    // 加载单个产品
    async loadProduct(gid) {
        try {
            const productId = gid.split('/').pop();
            const recommendationsUrl = `/recommendations/products.json?product_id=${productId}&limit=1`;

            let productData = null;

            try {
                const response = await fetch(recommendationsUrl);
                if (response.ok) {
                    const data = await response.json();
                    if (data.products && data.products.length > 0) {
                        productData = data.products[0];
                    }
                }
            } catch (e) {
                console.log('Recommendations API not available');
            }

            if (productData) {
                this.productCache[gid] = productData;
            } else {
                throw new Error(`Could not load product ${productId} - may need to use product handles instead of IDs`);
            }

        } catch (error) {
            console.error('Error loading product:', gid, error);
        }
    }

    // 格式化 Admin API 返回的产品数据
    formatAdminProduct(product) {
        return {
            id: product.id,
            title: product.title,
            handle: product.handle,
            featured_image: product.images && product.images[0] ? product.images[0].src : null,
            variants: product.variants.map(v => ({
                id: v.id,
                title: v.title,
                price: parseFloat(v.price) * 100 // 转换为 cents
            }))
        };
    }

    // 渲染所有产品信息
    renderAllProducts() {
        const items = this.querySelectorAll('.bundle-purchase__product-item');

        items.forEach(item => {
            const gid = item.dataset.productGid;
            const product = this.productCache[gid];

            if (!product) {
                console.warn('Product not found in cache:', gid);
                const titleEl = item.querySelector('.bundle-purchase__product-title');
                if (titleEl) {
                    titleEl.textContent = 'Product not found';
                }
                return;
            }


            // 更新图片
            const imageContainer = item.querySelector('.bundle-purchase__product-image');
            if (imageContainer && product.featured_image) {
                const img = document.createElement('img');
                img.src = product.featured_image;
                img.alt = product.title;
                img.loading = 'lazy';
                imageContainer.innerHTML = '';
                imageContainer.appendChild(img);
            }

            // 更新标题
            const titleEl = item.querySelector('.bundle-purchase__product-title');
            if (titleEl) {
                titleEl.textContent = product.title;
            }

            // 更新复选框数据
            const checkbox = item.querySelector('input[type="checkbox"]');
            if (checkbox) {
                checkbox.dataset.productId = product.id;

                // 获取价格和 variant ID
                let variantId = product.id;
                let price = product.price || 0;

                if (product.variants && product.variants.length > 0) {
                    variantId = product.variants[0].id;
                    price = product.variants[0].price || price;
                }

                checkbox.dataset.variantId = variantId;
                checkbox.dataset.price = price;

            }
        });
    }

    // 初始化交互
    initInteractions() {
        this.slides = Array.from(this.querySelectorAll('.bundle-purchase__slide'));

        // 初始化 Swiper
        if (this.bundleData.length > 1) {
            const swiperContainer = this.querySelector('.bundle-purchase__swiper');

            this.swiper = new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: false,
                pagination: {
                    el: '.bundle-purchase__pagination',
                    clickable: true,
                    bulletClass: 'bundle-purchase__pagination-dot',
                    bulletActiveClass: 'active'
                },
                navigation: {
                    nextEl: '.bundle-purchase__swiper-button-next',
                    prevEl: '.bundle-purchase__swiper-button-prev',
                },
                on: {
                    slideChange: () => {
                        const activeSlide = this.slides[this.swiper.activeIndex];
                        if (activeSlide) {
                            this.updatePricing(activeSlide);
                        }
                    }
                }
            });
        }

        this.slides.forEach((slide, index) => {
            // 复选框事件
            const checkboxes = slide.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', () => this.updatePricing(slide));
            });

            // 添加到购物车
            const addBtn = slide.querySelector('[data-add-to-cart]');
            if (addBtn) {
                addBtn.addEventListener('click', () => this.addToCart(slide));
            }
        });
    }

    // 更新价格
    updatePricing(slide) {
        const checkboxes = slide.querySelectorAll('input[type="checkbox"]:checked');
        const selectedCountEl = slide.querySelector('[data-selected-count]');
        const discountEl = slide.querySelector('[data-discount-amount]');
        const subtotalEl = slide.querySelector('[data-subtotal]');
        const totalEl = slide.querySelector('[data-total]');
        const addToCartBtn = slide.querySelector('[data-add-to-cart]');

        const bundleData = slide.querySelector('.bundle-purchase__data');
        const discountType = bundleData.querySelector('[data-discount-type]').textContent.trim();
        const discountValue2 = parseFloat(bundleData.querySelector('[data-discount-value2]').textContent) || 0;
        const discountValue3 = parseFloat(bundleData.querySelector('[data-discount-value3]').textContent) || 0;

        let subtotal = 0;
        let selectedCount = checkboxes.length;

        // 计算小计
        checkboxes.forEach(checkbox => {
            let price = parseFloat(checkbox.dataset.price) || 0;
            // Shopify Liquid 输出的价格已经是 cents 格式，转换为 dollars
            price = price / 100;
            subtotal += price;
        });

        // 确定折扣
        let discountValue = 0;
        if (selectedCount >= 3) {
            discountValue = discountValue3;
        } else if (selectedCount === 2) {
            discountValue = discountValue2;
        }

        let discount = 0;
        if (discountType === 'percentage') {
            discount = subtotal * (discountValue / 100);
        } else {
            discount = discountValue;
        }

        const total = Math.max(0, subtotal - discount);

        // 更新显示
        if (selectedCountEl) selectedCountEl.textContent = selectedCount;

        if (discountEl) {
            if (discountType === 'percentage') {
                discountEl.textContent = `${discountValue}%`;
            } else {
                discountEl.textContent = `$${discountValue.toFixed(2)}`;
            }
        }

        if (subtotalEl) subtotalEl.textContent = `$${subtotal.toFixed(2)}`;
        if (totalEl) totalEl.textContent = `$${total.toFixed(2)}`;
        if (addToCartBtn) addToCartBtn.disabled = selectedCount === 0;
    }
    // 删除 Cookie
    deleteCookie(name) {
        // 删除根路径的 cookie
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        // 删除当前路径的 cookie
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${window.location.pathname};`;
        // 删除带 domain 的 cookie
        const hostname = window.location.hostname;
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${hostname};`;
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${hostname};`;

    }

    // 添加到购物车
    async addToCart(slide) {
        const checkboxes = slide.querySelectorAll('input[type="checkbox"]:checked');
        const addToCartBtn = slide.querySelector('[data-add-to-cart]');
        const loadingSpinner = addToCartBtn.querySelector('.loading__spinner');
        const bundleData = slide.querySelector('.bundle-purchase__data');

        if (checkboxes.length === 0) {
            alert('Please select at least one product');
            return;
        }

        // 删除 cookie 中的 cart 和 discount_code
        this.deleteCookie('cart');
        this.deleteCookie('discount_code');

        if (addToCartBtn) {
            addToCartBtn.classList.add('loading');
            loadingSpinner.classList.remove('hidden');
        }

        try {
            // 获取折扣码
            const selectedCount = checkboxes.length;
            const twoCode = bundleData.querySelector('[data-two-code]').textContent.trim();
            const threeCode = bundleData.querySelector('[data-three-code]').textContent.trim();

            let discountCode = '';
            if (selectedCount >= 3 && threeCode) {
                discountCode = threeCode;
            } else if (selectedCount === 2 && twoCode) {
                discountCode = twoCode;
            }


            // 如果有折扣码，先通过 iframe 应用
            if (discountCode) {
                await this.applyDiscountViaIframe(discountCode);
            }

            // 添加产品到购物车
            const items = Array.from(checkboxes).map(checkbox => ({
                id: checkbox.dataset.variantId,
                quantity: 1
            }));

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items })
            });

            if (!response.ok) {
                throw new Error('Failed to add items to cart');
            }

            // 更新购物车计数
            this.updateCartCount();

            // 成功提示
            if (addToCartBtn) {
                addToCartBtn.classList.remove('loading');
                loadingSpinner.classList.add('hidden');
                setTimeout(() => {
                    addToCartBtn.classList.remove('loading');
                    loadingSpinner.classList.add('hidden');
                }, 2000);
            }

            // 触发事件
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            // 打开购物车抽屉
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
            }

        } catch (error) {
            console.error('Error adding to cart:', error);
            alert('Failed to add items. Please try again.');

            if (addToCartBtn) {
                addToCartBtn.classList.remove('loading');
                loadingSpinner.classList.add('hidden');
            }
        }
    }

    // 通过 iframe 应用折扣码
    async applyDiscountViaIframe(discountCode) {
        return new Promise((resolve, reject) => {
            // 移除已存在的 iframe
            const existingIframe = document.getElementById('buy-together-discount-iframe');
            if (existingIframe) {
                existingIframe.remove();
            }

            // 创建新的 iframe
            const iframe = document.createElement('iframe');
            iframe.id = 'buy-together-discount-iframe';
            iframe.style.display = 'none';
            iframe.frameBorder = '0';

            // 设置 iframe 的 src，应用折扣码并重定向回当前页面
            const currentPath = window.location.pathname;
            iframe.src = `/discount/${discountCode}?redirect=${currentPath}`;

            // 监听 iframe 加载完成
            iframe.onload = () => {
                // 延迟一下确保折扣码已应用
                setTimeout(() => {
                    resolve();
                }, 500);
            };

            iframe.onerror = () => {
                console.error('Failed to load discount iframe');
                // 即使失败也继续执行，不影响添加到购物车
                resolve();
            };

            // 添加到 body
            document.body.appendChild(iframe);

            // 设置超时，防止无限等待
            setTimeout(() => {
                console.warn('Discount iframe timeout');
                resolve();
            }, 3000);
        });
    }

    // 更新购物车计数
    async updateCartCount() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();

            const countBubbles = document.querySelectorAll('.cart-count-bubble span');
            countBubbles.forEach(bubble => {
                bubble.textContent = cart.item_count;
            });
        } catch (error) {
            console.error('Error updating cart count:', error);
        }
    }

}

// 注册自定义元素
if (customElements.get('bundle-purchase-component') === undefined) {
    customElements.define('bundle-purchase-component', BundlePurchaseComponent);
}
